import React, { createContext, useContext, useReducer, useEffect } from 'react';

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

const initialState = {
  cartItems: [],
  isCartOpen: false,
  isSmartCoti: false, 
};

const cartReducer = (state, action) => {
  switch (action.type) {
    case 'ADD_TO_CART':
      return {
        ...state,
        cartItems: [...state.cartItems, action.payload],
        isCartOpen: true,
        isSmartCoti: false, // Reset Smart Coti cuando agregamos productos
      };
    case 'REMOVE_FROM_CART':
      return {
        ...state,
        cartItems: state.cartItems.filter((item) => item !== action.payload),
      };
    case 'UPDATE_QUANTITY':
      return {
        ...state,
        cartItems: state.cartItems.map((item) =>
          item === action.payload.item ? { ...item, quantity: action.payload.quantity } : item
        ),
      };
    case 'TOGGLE_CART':
      return {
        ...state,
        isCartOpen: !state.isCartOpen,
        isSmartCoti: false, // Reset cuando cerramos
      };
    case 'OPEN_SMART_COTI':
      return {
        ...state,
        isCartOpen: true,
        isSmartCoti: true,
      };
    case 'SET_CART_ITEMS':
      return {
        ...state,
        cartItems: action.payload,
      };
    default:
      return state;
  }
};

export const CartProvider = ({ children }) => {
  const [state, dispatch] = useReducer(cartReducer, initialState);

  useEffect(() => {
    const savedCart = localStorage.getItem('cartItems');
    if (savedCart) {
      dispatch({ type: 'SET_CART_ITEMS', payload: JSON.parse(savedCart) });
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('cartItems', JSON.stringify(state.cartItems));
  }, [state.cartItems]);

  const addToCart = (product, variation, quantity) => {
    const newItem = { ...product, variation, quantity };
    dispatch({ type: 'ADD_TO_CART', payload: newItem });
  };

  const removeFromCart = (item) => {
    dispatch({ type: 'REMOVE_FROM_CART', payload: item });
  };

  const updateQuantity = (item, quantity) => {
    dispatch({ type: 'UPDATE_QUANTITY', payload: { item, quantity } });
  };

  const toggleCart = () => {
    dispatch({ type: 'TOGGLE_CART' });
  };

  const openSmartCoti = () => {
    dispatch({ type: 'OPEN_SMART_COTI' });
  };

  return (
    <CartContext.Provider
      value={{
        cartItems: state.cartItems,
        isCartOpen: state.isCartOpen,
        isSmartCoti: state.isSmartCoti,
        addToCart,
        removeFromCart,
        updateQuantity,
        toggleCart,
        openSmartCoti,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};